export const templateFolder = "freewall-templates";
